import { Box, Text, Title } from "@mantine/core";
import { observer } from "mobx-react";
import { EpisodeRow } from "./EpisodeRow";
import styles from "./styles/EpisodeRow.module.css";
import { useStores } from "@/hooks/useStores";
import type { ListeningEntry } from "@/stores/ListeningStore";

const SHELF_SIZE = 5;

const remainingText = (entry: ListeningEntry) => {
    if (entry.duration <= 0) return null;
    const minutes = Math.max(1, Math.round((entry.duration - entry.position) / 60));
    return `${minutes} min kvar`;
};

/** Episodes the listener has started and not finished, newest first */
export const ContinueListening = observer(() => {
    const { listeningStore } = useStores();
    const entries = listeningStore.inProgress.slice(0, SHELF_SIZE);

    if (entries.length === 0) {
        return null;
    }

    return (
        <Box component="section" aria-labelledby="continue-listening" mb="xl">
            <Title className={styles.heading} id="continue-listening" mb="sm" order={2}>
                Fortsätt lyssna
            </Title>
            <ul className={styles.list}>
                {entries.map((entry) => (
                    <EpisodeRow
                        episode={entry.episode as Episode}
                        note={
                            remainingText(entry) && (
                                <Text c="dimmed" size="sm">
                                    {remainingText(entry)}
                                </Text>
                            )
                        }
                        key={entry.episode.id}
                        podcast={entry.podcast as Podcast}
                        showPodcast
                        withMenu
                    />
                ))}
            </ul>
        </Box>
    );
});
